import React from 'react'
import { Box, FormLabel, Stack, TableCell, Typography } from '@mui/material'
import SimpleTable from 'common/AbstractTable/SimpleTable'
import ColorBoxInfo from 'common/Box/ColorBoxInfo'
import { RoundedButton } from 'common/Button/Button'
import { FormikProps } from 'formik'
import { IDeliveryDetails } from 'types/api/v1/org.type'

const rows = [
  {
    planName: 'Pro Plan 1',
    quantity: 100,
    details: 'Lorem ipsum dolor sit'
  },
  {
    planName: 'Pro Plan 2',
    quantity: 100,
    details: 'Lorem ipsum dolor sit'
  }
]

interface DeliverySummaryProps {
  setPreviousPage: (value: void) => void
  formik: FormikProps<IDeliveryDetails>
  formattedDeliveryDate: string
  deliveryTime: string
}

function DeliverySummary({
  setPreviousPage,
  formik,
  formattedDeliveryDate,
  deliveryTime
}: DeliverySummaryProps) {
  const companyDeliveryDetails = {
    userDetails: [
      {
        title: 'Contact&apos; Person Name',
        content: formik.values.contactName
      },
      {
        title: 'Contact Number',
        content: formik.values.contactNum
      },
      {
        title: 'Email',
        content: formik.values.email
      }
    ],
    address: [
      {
        title: 'Delivery Address',
        content: formik.values.formattedDeliveryAddress
      },
      {
        title: 'Billing Address',
        content: formik.values.formattedBillingAddress
      }
    ]
  }

  const tableBodyContent = rows.map((row) => (
    <React.Fragment key={row.planName}>
      <TableCell>
        <Typography>{row.planName}</Typography>
        <Typography sx={{ color: 'neutrals.500' }}>{row.details}</Typography>
      </TableCell>
      <TableCell align='center'>{row.quantity}</TableCell>
    </React.Fragment>
  ))

  return (
    <>
      <Typography variant='h4'>Delivery Summary</Typography>
      <Typography variant='subtitle1'>
        Here are the details of your delivery.
      </Typography>
      <Box sx={{ height: '60vh' }}>
        <Stack direction='row' spacing='5vw'>
          <Box sx={{ width: '50%' }}>
            <SimpleTable
              header='Delivery Items'
              tableHeaderCell={['Order Summary', 'Quantity']}
              tableBodyCell={tableBodyContent}
            />
            <ColorBoxInfo>
              <>
                <Typography variant='h5'>
                  Date: {formattedDeliveryDate}
                </Typography>
                <Typography variant='h5'>Time: {deliveryTime}</Typography>
              </>
            </ColorBoxInfo>
          </Box>
          {/* company details on the right */}
          <Box sx={{ width: '30%' }}>
            <FormLabel className='formSectionHeader'>Company Details</FormLabel>
            {companyDeliveryDetails.userDetails.map((detail) => (
              <Stack key={detail.title}>
                <FormLabel className='formSmallLabel'>{detail.title}</FormLabel>
                <Typography>{detail.content}</Typography>
              </Stack>
            ))}
            <FormLabel className='formSectionHeader'>
              Delivery & Billing Details
            </FormLabel>

            {companyDeliveryDetails.address.map((add) => (
              <Stack key={add.title}>
                <FormLabel className='formSmallLabel'>{add.title}</FormLabel>
                <Typography>{add.content}</Typography>
              </Stack>
            ))}
          </Box>
        </Stack>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <RoundedButton variant='secondary' onClick={() => setPreviousPage()}>
          Back
        </RoundedButton>
        <RoundedButton variant='filled'>Confirm</RoundedButton>
      </Box>
    </>
  )
}

export default DeliverySummary
